import React, { useState, useEffect } from 'react';

function MyFiles() {
  const [files, setFiles] = useState([]);

  // Helper function to fix paths
  const fixPath = (filePath) => {
    // Check if filePath starts with "/home", indicating it's an older entry with a full path
    if (filePath.startsWith('/home')) {
      // Extract the basename from the path and prepend it with "/app/uploads/"
      return '/app/uploads/' + filePath.split('/').pop();
    }
    // Otherwise, it's a newer entry, so we just prepend "/app/uploads/"
    return '/app/uploads/' + filePath;
  };

  useEffect(() => {
    fetch('/app/my-files', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Fix paths for each file entry
        const fixedFiles = data.map((file) => ({
          ...file,
          thumbnailPath: fixPath(file.thumbnailPath),
          downloadPath: fixPath(file.downloadPath),
        }));
        setFiles(fixedFiles);
      })
      .catch((error) => console.error('Error fetching files:', error));
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">My Files:</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {files.map((file, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-lg p-4 flex flex-col items-center"
          >
            <img
              src={file.thumbnailPath}
              alt={file.originalFilename}
              className="w-full h-48 object-cover rounded"
            />
            <h2 className="mt-4 text-lg font-medium">{file.originalFilename}</h2>
            <p className="text-gray-600 text-sm">
              Uploaded on: {new Date(file.uploadDate).toLocaleDateString()}
            </p>
            <p className="text-gray-600 text-sm">Duration: {file.duration} sec</p>
            <a
              href={file.downloadPath}
              download
              className="mt-4 inline-block bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-500"
            >
              Download
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MyFiles;
